var Handlebars = require("/home/admin/gitlab_code/enhancer/project-center-assets/node_modules/handlebars/runtime.js");
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "<ul class=\"project-tabs clearfix\">\n    <li data-tab=\"project-info\" class=\"selected\">\n        <i class=\"info circle icon\"></i>"
    + alias2(require("/home/admin/gitlab_code/enhancer/project-center-assets/helpers/i18n.js").call(alias1,"home.project.detail",{"name":"i18n","hash":{},"data":data}))
    + "\n    </li>\n    <li data-tab=\"delivery-management\"><i class=\"list icon\"></i>"
    + alias2(require("/home/admin/gitlab_code/enhancer/project-center-assets/helpers/i18n.js").call(alias1,"home.release.management",{"name":"i18n","hash":{},"data":data}))
    + "</li>\n    <li data-tab=\"authorization\"><i class=\"users icon\"></i>"
    + alias2(require("/home/admin/gitlab_code/enhancer/project-center-assets/helpers/i18n.js").call(alias1,"home.development.authorization",{"name":"i18n","hash":{},"data":data}))
    + "</li>\n</ul>\n\n<div class=\"project-wrap\">\n</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/projectDetail.html
// module id = 14
// module chunks = 0